import { useStore } from '@/store';
import { loadProfileData } from '@/services/api/api-services/load-profile';

export default async (to: any, from: any, next: Function) => {
  const store = useStore();
  if (store.authToken) {
    if (!store.isProfileLoaded) {
      try {
        await loadProfileData();
      } catch {
        return next({ path: '/logout' });
      }
    }

    const user = store.user as any;
    const isCurrencyRequired = user?.id && !user?.currencyId;
    const isEmailVerificationRequired = user?.id && !user?.emailVerified;

    if(isEmailVerificationRequired){
      return next({ name: 'register-email-verification'});
    }

    if(isCurrencyRequired){
      return next();
    }else{
      return from?.name ? next(false) : next('/');
    }
  }

  return next({ path: '/login', query: { redirect: to.fullPath } });
}
